import React, {useEffect} from "react";

import {getAdminLogs, getAdminMessages, getLatestLeads} from "../../services/AdminService";
import {AdminLogGrid} from "../Components/AdminLogs/AdminLogGrid";
import {Button, ButtonGroup, Col, Container, Row} from "react-bootstrap";
import {AdminUserLogGrid} from "../Components/AdminUsers/AdminUserLogGrid";
import {AdminShowMessagesGrid} from "../Components/AdminLogs/AdminShowMessagesGrid";
import {getApiLogsClient} from "../../services/PandaDocService";
import LeadsGrid from "../../components/LeadsGrid";
import {AdminLeadGrid} from "../Components/AdminLeads/AdminLeadGrid";


export const AdminLog = () => {

    const [error, setError] = React.useState(false);
    const [errorText, setErrorText] = React.useState("");

    const [showAddedCompanies, setShowAddedCompanies] = React.useState(false);
    const [showRemovedUsers, setShowRemovedUsers] = React.useState(false);
    const [showMessages, setShowMessages] = React.useState(false);
    const [showPandaDocAPI, setShowPandaDocAPI] = React.useState(false);
    const [showLatestLeads, setShowLatestLeads] = React.useState(false);


    const [logs, setLogs] = React.useState([]);
    const [adminMessages, setAdminMessages] = React.useState([]);
    const [latestLeads, setLatestLeads] = React.useState();

    const fetchData = React.useCallback(async () => {
        try {
            const log = await getAdminLogs();
            const adminMessages = await getAdminMessages();
            const getLeads = await getLatestLeads();

            setLogs(log);
            setAdminMessages(adminMessages);
            setLatestLeads(getLeads);
        } catch {
            setError(true);
            setErrorText("Fel uppstod")
        }
    })

    useEffect(() => {
        fetchData();
        console.log(latestLeads)
    }, [])

    const declareBtnClr = (value) => {
        if (value === true) {
            return "warning"
        } else
            return "success"
    }

    return (
        <Container>
            <>
                <Button variant={declareBtnClr(showAddedCompanies)}
                        onClick={() => setShowAddedCompanies(!showAddedCompanies)}>Visa Tillagda Företag</Button>
                <Button variant={declareBtnClr(showRemovedUsers)}
                        onClick={() => setShowRemovedUsers(!showRemovedUsers)}>Visa Borttagna användare</Button>
                <Button variant={declareBtnClr(showMessages)} onClick={() => setShowMessages(!showMessages)}>Visa
                    Meddelanden till Leadtub</Button>
                <Button variant={declareBtnClr(showLatestLeads)} onClick={() => setShowLatestLeads(!showLatestLeads)}>Visa
                    Senaste Leads</Button>
                <Button variant={declareBtnClr(showPandaDocAPI)} onClick={() => setShowPandaDocAPI(!showPandaDocAPI)}>
                    (work in progress) Visa
                    pandadocAPi</Button>

            </>
            <Row>
                <Col>
                    {showAddedCompanies ?
                        <AdminLogGrid logs={logs}/>
                        : null}
                </Col>
                <Col>
                    {showRemovedUsers ? <AdminUserLogGrid users={logs}/>
                        : null}
                </Col>
            </Row>
            <Row>
                <Col>
                    {showMessages ?
                        <AdminShowMessagesGrid logs={adminMessages}/> : null
                    }
                </Col>
                <Col>
                    {showLatestLeads ?
                        <AdminLeadGrid leads={latestLeads}/> : null
                    }
                    {showPandaDocAPI ?
                        <>

                        </> : null
                    }
                </Col>
            </Row>
        </Container>
    )
}
